import {renderCalendarContainer, renderTimeSlot} from "../utils/templates";
import {isNonNullObject} from "../utils/helpers.js";

export default class CalendarStep {
    constructor() {
        this.id = "calendar";
        this.title_key = "choose_appointment_time";
    }

    init({$, state, data, emit}) {
        this.$ = $;
        this.state = state;
        this.data = data;
        this.emit = emit;
        this.selected = state.selectedEmployee || null;
    }

    render(container) {
        const $ = this.$;
        const html = renderCalendarContainer();
        container.html(html);
        this.container = container;
        this.$spinner = $('.spinner-overlay', this.container);
        this.getAvailableDates();
        $('.booking-list-holder .btn-confirm', this.container).on('click', () => this.next());
        $('.step-no-calendar', this.container).hide();
    }

    getAvailableDates() {
        const $ = this.$;
        const $spinner = this.$spinner.show();

        const queryOptions = $.extend({}, this.getQueryOptions());
        $.ajax({
            type: 'GET',
            headers: {
                'X-CSRF-Token': this.data.token,
            },
            url: this.data.apiRoutes.datesAvailability,
            data: queryOptions,
            complete: function () {
                $spinner.hide();
            },
            success: $.proxy(function(dates) {
                if(dates.length > 0) {
                    this.renderFlatpickr(dates);
                } else {
                    this.noDatesAvailable();
                }
            }, this)
        });
    }

    getQueryOptions() {
        // Build query options dynamically
        const queryOptions = {
            locationId: this.state.selectedLocation > 0 ? this.state.selectedLocation : undefined,
            employeeId: this.state.selectedEmployee > 0 ? this.state.selectedEmployee : undefined,
        };

        // If a subscription is selected, adjust the query accordingly
        if (isNonNullObject(this.state.selectedSubscription)) {
            queryOptions.subscriptionId = this.state.selectedSubscription.id;
            delete queryOptions.serviceId; // Subscriptions override services
        } else {
            queryOptions.serviceId = Array.isArray(this.state.selectedServices) && this.state.selectedServices.length
                ? this.state.selectedServices
                : undefined;
        }

        // Clean up any undefined or null values to avoid sending unnecessary params
        $.each(queryOptions, function(key, value) {
            if (value === undefined || value === null) {
                delete queryOptions[key];
            }
        });

        return queryOptions;
    }

    renderFlatpickr(dates) {
        const $ = this.$;
        $('.step-no-calendar', this.container).hide();
        $('.step-calendar-columns', this.container).show();
        const ctx = this;
        const options = $.extend({}, {
            inline: true,
            locale: this.data.lng || 'en', // TODO
            enable: dates.map(function (date) {
                return ({
                    from: date,
                    to: date
                });
            }),
            maxDate: dates[dates.length - 1],
            minDate: dates[0],
            onChange: function (selectedDates, dateStr) {
                ctx.date = dateStr;
                ctx.startAt = '';
                ctx.endAt = '';
                ctx.renderBookings(dateStr);
            },
            defaultDate: this.state.date ? this.state.date : undefined,
            monthSelectorType: 'static'
        });

        $('.flat-picker-container', this.container).flatpickr(options);
    }

    renderBookings(dateStr)  {
        const $ = this.$;
        // prevent booking
        const $spinner = this.$spinner.show();
        $('.booking-list-holder button', this.container).prop('disabled', true); // will disable all buttons.
        const ctx = this;
        // const queryOptions = $.extend({}, {
        //     locationId: this.state.selectedLocation > 0 ? this.state.selectedLocation : undefined,
        //     employeeId: this.state.selectedEmployee > 0 ? this.state.selectedEmployee : undefined,
        //     serviceId: Array.isArray(this.state.selectedServices) ? this.state.selectedServices : undefined,
        //     checkDate: dateStr ? dateStr : undefined
        // });

        const queryOptions = {
            ...this.getQueryOptions(),
            ...(dateStr && { checkDate: dateStr }),
        };

        $.ajax({
            type: 'GET',
            headers: {
                'X-CSRF-Token': this.data.token,
            },
            url: this.data.apiRoutes.hoursAvailability,
            data: queryOptions,
            complete: function () {
                $spinner.hide();
            },
            success: $.proxy(function(slots) {
                const $bookingList = $('.booking-list-container', this.container);
                $('.booking-list-title', this.container).hide();
                $bookingList.empty();

                $.each(slots, function(index, obj) {
                    obj.index = index;
                    let $currentSlot = $(renderTimeSlot(obj));
                    $currentSlot.on('click', () => ctx.selectSlot(obj));
                    if (obj.available) {
                        // if (obj.startAt == ctx.state.startAt) {
                        //     $currentSlot.addClass('active');
                        //     $('.booking-list-holder button', this.container).removeAttr('disabled');
                        // }
                        $bookingList.append($currentSlot);
                    }
                });
                if ($(".booking-list-container button").length === 0) {
                    $bookingList.append(
                        '<p style="grid-column-start: 1; grid-column-end: 5; text-align: center; color: #e97246;">Nu s-a găsit o oră disponibilă<br>Vă rugăm alegeți o altă zi.</p>'
                    );
                }
                // const $bw = $bookingList.closest('.booking-widget');
                // const $stepsHolder = $bookingList.closest('.booking-steps-holder');
                // $stepsHolder.animate({
                //     scrollTop: $bookingList.offset().top - 300
                // }, 500, 'linear', function() {
                //     $stepsHolder.stop(true);
                // });

                const stepsHolder = $bookingList.closest('.booking-steps-holder')[0];
                const offset = $bookingList[0].getBoundingClientRect().top
                    - stepsHolder.getBoundingClientRect().top;

                stepsHolder.scrollTo({
                    top: stepsHolder.scrollTop + offset,
                    behavior: 'smooth'
                });

                // $([document.documentElement, document.body]).animate({
                //     scrollTop: $bookingList.offset().top - 300
                // }, 500, 'linear', function() {
                //     $([document.documentElement, document.body]).stop(true);
                // });
            }, this)
        });
    }

    selectSlot({startAt, endAt, available, index}) { // eslint-disable-line
        if (available) {
            this.startAt = startAt;
            this.endAt = endAt;
            $('.booking-list-container button', this.container).removeClass('active');
            $(`.booking-list-container button[data-id="${index}"]`, this.container).addClass('active');
            console.log($('.booking-list-holder button', this.container));
            $('.booking-list-holder button', this.container).removeAttr('disabled');
        }
    }

    next() {
        console.log('next');
        if(this.date && this.startAt) {

            this.state.date = this.date;
            this.state.startAt = this.startAt;
            this.state.endAt = this.endAt;

            this.emit('calendar_selected', { date: this.date, startAt: this.startAt });
        }
    }

    noDatesAvailable() {
        $('.step-no-calendar', this.container).show();
        $('.step-calendar-columns', this.container).hide();
    }
};